const translations = {
    label: 'Switch to classic'
};

export default translations;
